import React from "react";
import { Chip } from "@mui/material";

const ActiveFilterBar = ({ chips, onRemove, onClearAll }) => {
  if (!chips || chips.length === 0) return null;

  return (
    <div className="col-span-12 flex flex-wrap items-center gap-2 mt-4 px-2 mb-2 font-poppins">
      <span className="text-[14px] font-[600] text-[#A0AEC0] mr-1">Active Filters:</span>
      {chips.slice(0, 3).map((chip, index) => (
        <Chip
          key={`${chip.id}-${index}`}
          label={chip.label}
          onDelete={() => onRemove(chip)}
          deleteIcon={
            <svg width="10" height="10" viewBox="0 0 14 14" fill="none" style={{ marginLeft: '4px', cursor: 'pointer', opacity: 0.9 }}>
              <path d="M1 1L13 13M1 13L13 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          }
          sx={{
            backgroundColor: '#00ADEF',
            color: 'white',
            height: '32px',
            fontSize: '13px',
            fontWeight: 500,
            fontFamily: 'Poppins, sans-serif',
            borderRadius: '16px',
            px: 1,
            '& .MuiChip-label': {
              paddingLeft: '8px',
              paddingRight: '4px',
            },
            '& .MuiChip-deleteIcon': {
              marginLeft: '0px',
              marginRight: '8px',
              opacity: 0.8,
              '&:hover': { opacity: 1 }
            }
          }}
        />
      ))}
      {chips.length > 3 && (
        <Chip
          label={`+${chips.length - 3} More`}
          sx={{
            backgroundColor: '#00ADEF',
            color: 'white',
            height: '32px',
            fontSize: '13px',
            fontWeight: 500,
            fontFamily: 'Poppins, sans-serif',
            borderRadius: '16px'
          }}
        />
      )}
      <button
        onClick={onClearAll}
        className="ml-2 text-[#00ADEF] text-[14px] font-[600] hover:underline cursor-pointer font-poppins"
      >
        Clear All
      </button>
    </div>
  );
};

export default ActiveFilterBar;
